import cn from 'classnames';

const ChatsRowItem = ({
  children,
  className,
  onClick,
  id = 'chats-row-item',
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  onClick?: () => void;
}) => {
  return (
    <div
      id={id}
      onClick={onClick}
      className={cn(
        'border-b border-lightGray flex items-center hover:text-brand-primary transition-colors duration-200',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default ChatsRowItem;
